import { cva } from 'class-variance-authority';

export const cvaAddParkingPageWrap = cva([
  'AddParkingPageStyles-cvaAddParkingPageWrap',
  'flex items-center m-auto',
  'h-[calc(100vh-2.4rem)]',
]);

export const cvaAddParkingPageImage = cva([
  'AddParkingPageStyles-cvaAddParkingPageImage',
  'flex justify-center items-center',
  'w-[14rem] h-[14rem]',
  'relative m-auto',
]);

export const cvaAddParkingPageGradient = cva([
  'AddParkingPageStyles-cvaAddParkingPageImage',
  'w-[30rem] min-w-[30rem] h-[30rem]',
  'absolute inset-[-8rem] z-[-1]',
]);

export const cvaAddParkingPageIcon = cva([
  'AddParkingPageStyles-cvaAddParkingPageImage',
  'w-[14rem] h-[14rem]',
]);

export const cvaAddParkingPageTitle = cva([
  'AddParkingPageStyles-cvaAddParkingPageTitle',
  'text-[2.4rem] text-center text-cWhite font-extrabold',
  'mt-2',
]);

export const cvaAddParkingPageLabel = cva([
  'AddParkingPageStyles-cvaAddParkingPageLabel',
  'block',
  'mt-0.8',
  'text-m-sb text-center text-cGray',
]);

export const cvaAddParkingPageText = cva([
  'AddParkingPageStyles-cvaAddParkingPageText',
  'block',
  'ml-3.6 mt-0.8',
  'text-m-sb text-cGray',
]);

export const cvaAddParkingPageLink = cva([
  'AddParkingPageStyles-cvaAddParkingPageLink',
  'block',
  'ml-3.6 mt-0.8',
  'text-m-sb text-cGreen',
]);

export const cvaAddParkingPageButtons = cva([
  'AddParkingPageStyles-cvaAddParkingPageButtons',
  'flex flex-col gap-1.2',
  'mt-2.4',
]);
